var map = {
	"./azure.svg": 690,
	"./cpp.svg": 290,
	"./css.svg": 588,
	"./dart.svg": 69,
	"./django.svg": 549,
	"./docker.svg": 844,
	"./flutter.svg": 331,
	"./git.svg": 929,
	"./github.svg": 288,
	"./html.svg": 466,
	"./java.svg": 554,
	"./javascript.svg": 146,
	"./kotlin.svg": 744,
	"./kubernetes.svg": 922,
	"./linkedin.svg": 774,
	"./mysql.svg": 262,
	"./postgresql.svg": 196,
	"./python.svg": 978,
	"./pytorch.svg": 178,
	"./qt.svg": 344,
	"./react.svg": 485,
	"./redis.svg": 555,
	"./spring.svg": 411,
	"./sqlite.svg": 439,
	"./twitter.svg": 901,
	"./typescript.svg": 785,
	"./vue.svg": 698
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 284;